import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: 'db-empty-search',
    templateUrl: './empty-search.component.html',
    styleUrls: ['./empty-search.component.scss'],
    standalone: false
})
export class EmptySearchComponent {
  @Input() hideImage: boolean;
  @Input() textTitle?: any;
  @Input() page: any;
  @Output() onClickAction?: EventEmitter<any> = new EventEmitter<any>();

  public showAvailablePlugins() {
    this.onClickAction.emit();
  }

}
